import { createFileRoute } from '@tanstack/react-router';
import { CategoriesPage } from '@/features/admin/Categories';

export const Route = createFileRoute('/_app/categories')({ component: CategoriesPage });
